export const SUPPORTED_LANGUAGES = ['en', 'sv'];
export const SUPPORTED_LOCALES = ['en-US', 'sv-SE'];
export const DEFAULT_LANGUAGE = 'en';
export const DEFAULT_LOCALE = 'en-US';
export const LANGUAGE_LABELS = {
    en: 'English',
    sv: 'Svenska',
};
// Keep deliberately: part of the published @ayeldo/frontend-core public surface; preserve for downstream consumers.
export const LOCALE_LABELS = {
    'en-US': 'United States',
    'sv-SE': 'Sverige',
};
export function isSupportedLanguage(value) {
    return SUPPORTED_LANGUAGES.includes(value);
}
export function isSupportedLocale(value) {
    return SUPPORTED_LOCALES.includes(value);
}
